import {connect} from 'react-redux';
import PurchaseLimitIndex from "./purchase_limit_index";
import {
  getCurrentLimitList
} from "../../selectors/purchase_limits/purchase_limits_selectors";
import "./style.css";
import { FOUR_DECIMAL_PLACES } from './purchase_limits_const';

const mapStateToProps = (state) => {
  return ({
    limits: getCurrentLimitList(state),
    decimalPlaces: FOUR_DECIMAL_PLACES,
  })
};

const mapDispatchToProps = dispatch => {
  return ({

  })
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseLimitIndex)


// WEBPACK FOOTER //
// ./src/components/purchase_limits/purchase_limit_index_container.js